import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import Login from "@/pages/Login";
import Dashboard from "@/pages/Dashboard";
import Tickets from "@/pages/Tickets";
import TicketDetail from "@/pages/TicketDetail";
import TicketCreate from "@/pages/TicketCreate";
import Payments from "@/pages/Payments";
import Manage from "@/pages/Manage";
import Reports from "@/pages/Reports";
import Recurring from "@/pages/Recurring";
import Inventory from "@/pages/Inventory";
import Roster from "@/pages/Roster";
import Notices from "@/pages/Notices";
import Planner from "@/pages/Planner";
import AdminVisits from "@/pages/AdminVisits";
import Settings from "@/pages/Settings";
import Layout from "@/components/Layout";
import ChangePassword from "@/pages/ChangePassword";
import PublicRaise from "@/pages/PublicRaise";

function Protected({ children, roles }) {
  const { user, ready } = useAuth();
  if (!ready) return <div className="p-8 text-slate-500">Loading…</div>;
  if (!user) return <Navigate to="/login" replace />;
  if (user.must_change_password) return <Navigate to="/change-password" replace />;
  if (roles && !roles.includes(user.role)) return <Navigate to="/" replace />;
  return <Layout>{children}</Layout>;
}

function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Toaster position="top-center" richColors closeButton />
        <Routes>
          <Route path="/login" element={<Login />} />
          <Route path="/change-password" element={<ChangePassword />} />
          <Route path="/raise/:outletId" element={<PublicRaise />} />
          <Route path="/" element={<Protected><Dashboard /></Protected>} />
          <Route path="/tickets" element={<Protected><Tickets /></Protected>} />
          <Route path="/tickets/new" element={<Protected roles={["admin","hod","facility_incharge","outlet_incharge","outlet_staff"]}><TicketCreate /></Protected>} />
          <Route path="/tickets/:id" element={<Protected><TicketDetail /></Protected>} />
          <Route path="/payments" element={<Protected roles={["admin","manager","op_manager","facility_incharge"]}><Payments /></Protected>} />
          <Route path="/manage" element={<Protected roles={["admin","manager","op_manager"]}><Manage /></Protected>} />
          <Route path="/reports" element={<Protected roles={["admin","manager","op_manager"]}><Reports /></Protected>} />
          <Route path="/recurring" element={<Protected roles={["admin","manager","op_manager"]}><Recurring /></Protected>} />
          <Route path="/inventory" element={<Protected roles={["admin","manager","op_manager","facility_incharge"]}><Inventory /></Protected>} />
          <Route path="/roster" element={<Protected><Roster /></Protected>} />
          <Route path="/notices" element={<Protected><Notices /></Protected>} />
          <Route path="/planner" element={<Protected roles={["op_manager","admin"]}><Planner /></Protected>} />
          <Route path="/admin/visits" element={<Protected roles={["admin"]}><AdminVisits /></Protected>} />
          <Route path="/settings" element={<Protected><Settings /></Protected>} />
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}

export default App;
